import React from 'react';
import Alert from './Alert';

export default (props) => <Alert level="warning" {...props} />;
